import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';

const { type } = colors;

export const COLOR_TYPES = [
  type.ACTIVE,
  type.INFO,
  type.SUCCESS,
  type.DANGER,
  type.WARNING,
  type.DARKEST,

  //DEPRECATED COLORS REMOVE THIS AS SOON AS POSSIBLE
  type.BRAND_PRIMARY,
  type.BRAND_INFO,
  type.BRAND_SUCCESS,
  type.BRAND_DANGER,
  type.BRAND_WARNING,
  type.BLUE_DARK,
  type.BLUE_MEDIUM,
  type.BLUE_LIGHT
];

export const SQUARE_SHAPE = 'square';
export const ROUNDED_SHAPE = 'rounded';
export const CIRCLE_SHAPE = 'circle';

export const SHAPE_TYPES = [SQUARE_SHAPE, ROUNDED_SHAPE, CIRCLE_SHAPE];

export const ICONS = icons.names;

export const CONTENT_ALIGN_CENTER = 'center';
export const CONTENT_ALIGN_LEFT = 'left';
export const ALIGN_TYPES = [CONTENT_ALIGN_CENTER, CONTENT_ALIGN_LEFT];
export const CIRLE_SHAPE_SIZES = ['small', 'regular', 'large'];
